module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "show-close": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h1', [_vm._v("QR-koder")])])])]), _vm._v(" "), (_vm.hasValidCodes && _vm.hasCodes) ? _c('div', {
    staticClass: "qr-code-wrapper"
  }, _vm._l((_vm.params.order.qrCodes), function(code, index) {
    return _c('div', {
      key: index,
      staticClass: "qr-code"
    }, [_c('h3', [_vm._v(_vm._s(code.product))]), _vm._v(" "), _c('img', {
      staticClass: "qr",
      attrs: {
        "src": _vm.qrUrl(code.ordernumber)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(code.ordernumber))])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.hasValidCodes && _vm.hasCodes) ? _c('div', [_c('p', [_vm._v("QR-koderna aktiveras några dagar innan ankomst.")])]) : _vm._e(), _vm._v(" "), (!_vm.hasValidCodes && !_vm.hasCodes) ? _c('div', [_c('p', [_vm._v("Det finns inga giltiga QR-koder.")])]) : _vm._e(), _vm._v(" "), (_vm.isCreating) ? _c('button', {
    staticClass: "small white border",
    staticStyle: {
      "margin-top": "50px"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Stäng")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-446604c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/QrModal.vue
// module id = 945
// module chunks = 0